import React, { useEffect, useState, useRef, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import Loader from "../../Components/Loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListPayments(props) {
  const [loading, setLoading] = useState(false);
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [userId, setUserId] = useState();
  let history = useHistory();

  useEffect(() => {
    if (apiToken) {
      if (query.get("id")) {
        setLoading(true);
        Repo.getListPaymentOperator(apiToken, query.get("id"))
          .then((response) => {
            if (response.status == 200) {
              setPaymentsTemp(response.data);
              setUserId(response.data[0]?.subscription?.user?.id);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, []);

  return (
    <>
      {paymentsTemp && paymentsTemp.length > 0 ? (
        <ListPaymemtsUsers
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
          fiscalCode={true}
          goBack={true}
          userId={userId}
        />
      ) : (
        <>
          <div className="alert alert-warning" role="alert">
            <strong>Attenzione! </strong> Non ci sono pagamenti per l'utente
            selezionato.
          </div>
        </>
      )}
      {loading && <Loader></Loader>}
    </>
  );
}

export default ListPayments;
